module.exports = __webpack_public_path__ + "media/country_flags/jo-d16fb2d8.png";